// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from '@lmc/ui-kit/src/feedback'
import AnimateHeight from 'react-animate-height'

export default function ErrorBox({ errors, style }) {
  const hasErrors = !!(errors && errors.length)
  const formattedErrors = hasErrors
    ? errors.map((err, i) => <div key={i}>{String(err)}</div>)
    : null
  return (
    <AnimateHeight
      animateOpacity
      duration={200}
      height={hasErrors ? 'auto' : 0}
    >
      <Alert
        key="error"
        type="error"
        style={style}
        message={formattedErrors}
      ></Alert>
    </AnimateHeight>
  )
}

ErrorBox.propTypes = {
  errors: PropTypes.array,
  style: PropTypes.object
}
